(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ezra-corporate-gifting"] && !Shopify.designMode) return;
  try {
    
(function () {
  function fmtMoney(cents, format) {
    var n = (cents || 0) / 100;
    function d(num, dec, ts, ds) {
      var p = num.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return p.join(ds);
    }
    return (format || '$' + '{' + '{amount}' + '}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return d(n, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return d(n, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return d(n, 0, '.', ',');
      if (k === 'amount_with_apostrophe_separator') return d(n, 2, "'", '.');
      return d(n, 2, ',', '.');
    });
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function syncCartCount(cart) {
    var sel = '[data-cart-count], .cart-count, .cart-count-bubble span[aria-hidden="true"], #CartCount, .js-cart-count, .cart-link__bubble-num';
    document.querySelectorAll(sel).forEach(function (el) { el.textContent = cart.item_count; });
    document.dispatchEvent(new CustomEvent('ezra:cart:added', { detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
  }

  function initCard(card, root) {
    var dataEl = card.querySelector('[data-ecg-data]');
    if (!dataEl) return;
    var products = JSON.parse(dataEl.textContent);
    var fmt = root.dataset.moneyFormat;
    var soon = card.dataset.soon === 'true';
    var descOverride = card.dataset.descOverride === 'true';
    var L = {
      add: root.dataset.labelAdd, added: root.dataset.labelAdded,
      sold: root.dataset.labelSoldOut, na: root.dataset.labelUnavailable,
      soon: card.dataset.soonLabel
    };
    var el = {
      img: card.querySelector('[data-ecg-img]'),
      price: card.querySelector('[data-ecg-price]'),
      compare: card.querySelector('[data-ecg-compare]'),
      desc: card.querySelector('[data-ecg-desc]'),
      blend: card.querySelector('[data-ecg-blend]'),
      opts: card.querySelector('[data-ecg-opts]'),
      id: card.querySelector('[data-ecg-id]'),
      qty: card.querySelector('[data-ecg-qty]'),
      add: card.querySelector('[data-ecg-add]'),
      err: card.querySelector('[data-ecg-error]'),
      form: card.querySelector('[data-ecg-form]')
    };
    var pIndex = 0, variant = null, addedTimer;

    function product() { return products[pIndex]; }
    function isSingle(p) { return p.variants.length === 1 && p.options.length === 1 && p.options[0] === 'Title'; }

    function buildOptions() {
      var p = product();
      if (isSingle(p)) { el.opts.innerHTML = ''; el.opts.hidden = true; return; }
      var start = p.variants.find(function (v) { return v.available; }) || p.variants[0];
      el.opts.hidden = false;
      el.opts.innerHTML = p.options.map(function (name, i) {
        var vals = [];
        p.variants.forEach(function (v) { if (vals.indexOf(v.options[i]) < 0) vals.push(v.options[i]); });
        var id = card.id + '-o' + i;
        return '<div class="ecg-field"><label for="' + id + '">' + esc(name) + '</label>' +
          '<select id="' + id + '" data-ecg-option="' + i + '">' +
          vals.map(function (val) { return '<option' + (val === start.options[i] ? ' selected' : '') + '>' + esc(val) + '</option>'; }).join('') +
          '</select></div>';
      }).join('');
    }

    function findVariant() {
      var p = product();
      var sels = Array.prototype.slice.call(el.opts.querySelectorAll('[data-ecg-option]'));
      if (!sels.length) return p.variants[0];
      var vals = sels.map(function (s) { return s.value; });
      return p.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === vals[i]; });
      }) || null;
    }

    function update() {
      var p = product();
      variant = findVariant();
      var src = (variant && variant.image) || p.image;
      if (el.img && src && el.img.getAttribute('src') !== src) {
        el.img.removeAttribute('srcset');
        el.img.src = src;
        el.img.alt = p.title + (variant && !isSingle(p) ? ', ' + variant.title : '');
      }
      if (!descOverride && el.desc && p.desc) el.desc.textContent = p.desc;
      if (!soon) {
        el.price.textContent = variant ? fmtMoney(variant.price, fmt) : L.na;
        if (variant && variant.compare > variant.price) {
          el.compare.textContent = fmtMoney(variant.compare, fmt);
          el.compare.hidden = false;
        } else { el.compare.hidden = true; }
      }
      var can = !soon && variant && variant.available;
      el.add.disabled = !can;
      el.add.classList.remove('is-added');
      el.add.textContent = soon ? L.soon : !variant ? L.na : variant.available ? L.add : L.sold;
      if (variant) el.id.value = variant.id;
    }

    if (el.blend) el.blend.addEventListener('change', function () {
      pIndex = parseInt(el.blend.value, 10) || 0;
      buildOptions(); update();
    });
    el.opts.addEventListener('change', update);

    card.querySelectorAll('[data-ecg-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        el.qty.value = Math.max(1, (parseInt(el.qty.value, 10) || 1) + parseInt(b.dataset.ecgStep, 10));
      });
    });
    el.qty.addEventListener('change', function () { el.qty.value = Math.max(1, parseInt(el.qty.value, 10) || 1); });

    el.form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!variant || el.add.disabled) return;
      var qty = Math.max(1, parseInt(el.qty.value, 10) || 1);
      el.qty.value = qty;
      var props = {};
      card.querySelectorAll('[data-ecg-prop]').forEach(function (s) { props[s.dataset.ecgProp] = s.value; });
      var item = { id: variant.id, quantity: qty };
      if (Object.keys(props).length) item.properties = props;

      el.add.disabled = true;
      el.add.setAttribute('aria-busy', 'true');
      el.err.hidden = true;
      var ok = false, title = product().title;

      fetch(root.dataset.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [item] })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || 'This item could not be added. Please try again.');
          return fetch(root.dataset.cartUrl + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          ok = true;
          syncCartCount(cart);
          afterAdd(root, cart, qty, title);
        })
        .catch(function (err) {
          el.err.textContent = err.message;
          el.err.hidden = false;
        })
        .finally(function () {
          el.add.removeAttribute('aria-busy');
          update();
          if (ok) {
            el.add.textContent = L.added;
            el.add.classList.add('is-added');
            clearTimeout(addedTimer);
            addedTimer = setTimeout(update, 1600);
          }
        });
    });

    if (el.blend) { buildOptions(); }
    update();
  }

  function afterAdd(root, cart, qty, title) {
    var mode = root.dataset.afterAdd;
    if (mode === 'cart') { window.location.href = root.dataset.cartUrl; return; }
    if (mode === 'checkout') { window.location.href = root.dataset.checkoutUrl; return; }
    if (mode === 'theme') return;
    var n = root.querySelector('[data-ecg-notice]');
    var msg = root.querySelector('[data-ecg-notice-msg]');
    msg.textContent = qty + ' × ' + title + ' added. Cart: ' + cart.item_count + (cart.item_count === 1 ? ' item, ' : ' items, ') + fmtMoney(cart.total_price, root.dataset.moneyFormat);
    n.hidden = false;
    clearTimeout(n._t);
    n._t = setTimeout(function () { n.hidden = true; }, 8000);
  }

  function initRoot(root) {
    if (root.__ecgReady) return;
    root.__ecgReady = true;
    root.querySelectorAll('[data-ecg-card]').forEach(function (c) { initCard(c, root); });
    var close = root.querySelector('[data-ecg-notice-close]');
    if (close) close.addEventListener('click', function () { root.querySelector('[data-ecg-notice]').hidden = true; });
  }

  function boot() { document.querySelectorAll('[data-ecg-root]').forEach(initRoot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-ecg-root]').forEach(initRoot);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ezra-corporate-intro"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Smooth-scroll any link pointing at this section's anchor, keeping it clear of the sticky header.
  // Height of the header when it stays pinned to the top while scrolling, else 0.
  function stickyHeaderHeight() {
    var el = document.querySelector('.m-header, sticky-header, header');
    while (el && el !== document.body) {
      var pos = getComputedStyle(el).position;
      if (pos === 'sticky' || pos === 'fixed') return el.getBoundingClientRect().height;
      el = el.parentElement;
    }
    return 0;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="#"]');
    if (!a) return;
    var hash = a.getAttribute('href').split('#')[1];
    if (!hash) return;
    var target = document.getElementById(hash);
    if (!target || !target.hasAttribute('data-eci-anchor')) return;
    e.preventDefault();
    var top = target.getBoundingClientRect().top + window.pageYOffset - stickyHeaderHeight();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
    if (history.replaceState) history.replaceState(null, '', '#' + hash);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ezra-corporate-shop"] && !Shopify.designMode) return;
  try {
    
(function () {
  function fmtMoney(cents, format) {
    var n = (cents || 0) / 100;
    function d(num, dec, ts, ds) {
      var p = num.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return p.join(ds);
    }
    return (format || '$' + '{' + '{amount}' + '}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return d(n, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return d(n, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return d(n, 0, '.', ',');
      if (k === 'amount_with_apostrophe_separator') return d(n, 2, "'", '.');
      return d(n, 2, ',', '.');
    });
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong. Please try again.');
        return j;
      });
    });
  }

  function foreignCurrency(root) {
    return root.dataset.currency && root.dataset.currency !== root.dataset.shopCurrency;
  }

  function currencyRate(root) {
    if (!foreignCurrency(root)) return 1;
    var r = window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate);
    return r > 0 ? r : 1;
  }

  function money(cents, root) {
    if (!foreignCurrency(root)) return fmtMoney(cents, root.dataset.moneyFormat);
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency', currency: root.dataset.currency
      }).format(cents / 100);
    } catch (e) {
      return root.dataset.currency + ' ' + (cents / 100).toFixed(2);
    }
  }

  function initCard(card, root) {
    var data = JSON.parse(card.querySelector('[data-ecs-data]').textContent);
    var L = root.dataset;
    // Tier prices are in store currency; variant prices are already in the shopper's currency.
    var rate = currencyRate(root);
    data.tiers.forEach(function (t) { if (t.price !== null) t.price = Math.round(t.price * rate); });
    // Information-only tier prices (store currency) shown in the shopper's currency.
    card.querySelectorAll('[data-ecs-static-price]').forEach(function (p) {
      p.textContent = money(Math.round(parseInt(p.dataset.ecsStaticPrice, 10) * rate), root);
    });
    var el = {
      img: card.querySelector('[data-ecs-img]'),
      unit: card.querySelector('[data-ecs-unit]'),
      total: card.querySelector('[data-ecs-total]'),
      tiers: card.querySelectorAll('[data-ecs-tier]'),
      tierPrices: card.querySelectorAll('[data-ecs-tier-price]'),
      opts: card.querySelectorAll('[data-ecs-option]'),
      id: card.querySelector('[data-ecs-id]'),
      qty: card.querySelector('[data-ecs-qty]'),
      hint: card.querySelector('[data-ecs-hint]'),
      add: card.querySelector('[data-ecs-add]'),
      quote: card.querySelector('[data-ecs-quote]'),
      err: card.querySelector('[data-ecs-error]'),
      form: card.querySelector('[data-ecs-form]')
    };
    var minMsg = el.hint ? (el.hint.dataset.message || '').replace('[min]', data.min) : '';
    var swapImage = card.dataset.swapImage === 'true';
    var totalWrap = card.querySelector('[data-ecs-total-wrap]');
    var variant = null, busy = false, addedTimer;

    function selectedValues() {
      var vals = data.variants[0].options.slice();
      el.opts.forEach(function (sel) { vals[parseInt(sel.dataset.ecsOption, 10)] = sel.value; });
      return vals;
    }

    function findVariant() {
      var vals = selectedValues();
      return data.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === vals[i]; });
      }) || null;
    }

    function qty() { return parseInt(el.qty.value, 10) || 0; }

    function tierIdx(q) {
      var idx = 0;
      data.tiers.forEach(function (t, i) { if (q >= t.min) idx = i; });
      return idx;
    }

    // Corporate variant for the selected options at quantity q (null without a corporate copy).
    function corpVariant(q) {
      if (!data.corp || !variant) return null;
      var c = data.corp;
      var want = variant.options.slice();
      want.splice(c.tierPos, 0, c.tierValues[tierIdx(q)]);
      return c.variants.find(function (v) {
        return v.options.every(function (o, k) { return o === want[k]; });
      }) || null;
    }

    function unitPrice(q) {
      var cv = corpVariant(q);
      if (cv) return cv.price;
      var price = variant ? variant.price : data.variants[0].price;
      data.tiers.forEach(function (t) {
        if (q >= t.min && t.price !== null) price = t.price;
      });
      return price;
    }

    function update() {
      variant = findVariant();
      var q = qty();
      var isQuote = q >= data.quoteMin;
      var belowMin = q < data.min;

      if (swapImage && el.img && variant && variant.image && el.img.getAttribute('src') !== variant.image) {
        el.img.removeAttribute('srcset');
        el.img.src = variant.image;
      }
      if (variant) el.id.value = variant.id;

      var unit = unitPrice(Math.max(q, data.min));
      el.unit.textContent = isQuote ? '—' : money(unit, root);
      el.total.textContent = isQuote ? '—' : money(unit * Math.max(q, data.min), root);
      el.tierPrices.forEach(function (p, i) { p.textContent = money(unitPrice(data.tiers[i].min), root); });

      var activeTier = null;
      el.tiers.forEach(function (b) { if (q >= parseInt(b.dataset.ecsTier, 10)) activeTier = b; });
      el.tiers.forEach(function (b) {
        b.classList.toggle('is-active', b === activeTier);
        b.setAttribute('aria-pressed', b === activeTier ? 'true' : 'false');
      });

      if (el.hint) {
        el.hint.textContent = minMsg;
        el.hint.classList.toggle('is-warn', belowMin);
      }

      el.add.hidden = isQuote;
      el.quote.hidden = !isQuote;
      if (busy) return;
      var can = variant && variant.available && !belowMin && (!data.corp || corpVariant(Math.max(q, data.min)));
      el.add.disabled = !can;
      el.add.classList.remove('is-added');
      el.add.textContent = !variant ? L.labelUnavailable : !variant.available ? L.labelSoldOut : L.labelAdd;
    }

    function setQty(n) {
      el.qty.value = Math.max(data.min, n || data.min);
      el.err.hidden = true;
      update();
    }

    el.opts.forEach(function (fs) { fs.addEventListener('change', update); });
    el.tiers.forEach(function (b) {
      b.addEventListener('click', function () { setQty(parseInt(b.dataset.ecsTier, 10)); });
    });
    card.querySelectorAll('[data-ecs-step]').forEach(function (b) {
      b.addEventListener('click', function () { setQty(qty() + parseInt(b.dataset.ecsStep, 10)); });
    });
    el.qty.addEventListener('input', update);
    el.qty.addEventListener('change', function () { setQty(qty()); });

    el.form.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = qty();
      if (q < data.min) { setQty(data.min); return; }
      if (q >= data.quoteMin || !variant || el.add.disabled) return;

      busy = true;
      el.add.disabled = true;
      el.add.setAttribute('aria-busy', 'true');
      el.err.hidden = true;
      var ok = false;

      var cv = corpVariant(q);
      postJSON(L.cartAdd + '.js', { items: [{ id: cv ? cv.id : variant.id, quantity: q }] })
        .then(function () { return syncNote(root); })
        .then(function () { return fetch(L.cartUrl + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); })
        .then(function (cart) {
          ok = true;
          // Cards set to hide the total reveal it once the item is in the cart.
          if (totalWrap) totalWrap.hidden = false;
          afterAdd(root, cart, q, data.title);
        })
        .catch(function (err) { el.err.textContent = err.message; el.err.hidden = false; })
        .finally(function () {
          busy = false;
          el.add.removeAttribute('aria-busy');
          update();
          if (ok) {
            el.add.textContent = L.labelAdded;
            el.add.classList.add('is-added');
            clearTimeout(addedTimer);
            addedTimer = setTimeout(update, 1800);
          }
        });
    });

    // Label option values that have no available variant for the current selection.
    function markAvailability() {
      var vals = selectedValues();
      el.opts.forEach(function (sel) {
        var i = parseInt(sel.dataset.ecsOption, 10);
        Array.prototype.forEach.call(sel.options, function (opt) {
          var test = vals.slice(); test[i] = opt.value;
          var exists = data.variants.some(function (v) {
            return v.available && v.options.every(function (o, k) { return o === test[k]; });
          });
          opt.textContent = opt.value + (exists ? '' : ' — ' + L.labelSoldOut);
        });
      });
    }
    el.opts.forEach(function (sel) { sel.addEventListener('change', markAvailability); });
    markAvailability();
    update();
  }

  /* Personalized note → cart attribute */
  function noteValue(root) {
    var box = root.querySelector('[data-ecs-note]');
    if (!box) return null;
    var on = box.querySelector('[data-ecs-note-toggle]').checked;
    return on ? box.querySelector('[data-ecs-note-input]').value.trim() : '';
  }

  // The note is the standard order note (cart.note), the same one the theme's cart drawer
  // and cart page edit, so it stays in sync everywhere and lands in the order's Notes.
  function syncNote(root) {
    var value = noteValue(root);
    if (value === null || value === root.__ecsSavedNote) return Promise.resolve();
    return postJSON(root.dataset.cartUpdate + '.js', { note: value }).then(function (cart) {
      root.__ecsSavedNote = cart.note || '';
      document.querySelectorAll('textarea[name="note"]').forEach(function (t) {
        if (!root.contains(t)) t.value = root.__ecsSavedNote;
      });
    });
  }

  function initNote(root) {
    var box = root.querySelector('[data-ecs-note]');
    if (!box) return;
    var toggle = box.querySelector('[data-ecs-note-toggle]');
    var field = box.querySelector('[data-ecs-note-field]');
    var input = box.querySelector('[data-ecs-note-input]');
    var status = box.querySelector('[data-ecs-note-status]');
    var count = box.querySelector('[data-ecs-note-count]');
    var timer;
    root.__ecsSavedNote = input.value.trim();

    function save() {
      if (noteValue(root) === root.__ecsSavedNote) return;
      status.textContent = 'Saving…';
      syncNote(root)
        .then(function () { status.textContent = noteValue(root) ? 'Saved to your order' : ''; })
        .catch(function () { status.textContent = 'Could not save. Please try again.'; });
    }

    // Keep this panel in step when the note is edited in the cart drawer.
    document.addEventListener('input', function (e) {
      var t = e.target;
      if (!t.matches || !t.matches('textarea[name="note"]') || root.contains(t)) return;
      input.value = t.value;
      count.textContent = t.value.length;
      toggle.checked = t.value.trim() !== '';
      field.hidden = !toggle.checked;
      root.__ecsSavedNote = t.value.trim();
    });

    toggle.addEventListener('change', function () {
      field.hidden = !toggle.checked;
      if (toggle.checked) input.focus();
      save();
    });
    input.addEventListener('input', function () {
      count.textContent = input.value.length;
      status.textContent = '';
      clearTimeout(timer);
      timer = setTimeout(save, 700);
    });
    input.addEventListener('blur', function () { clearTimeout(timer); save(); });
  }

  function afterAdd(root, cart, qty, title) {
    var mode = root.dataset.afterAdd;
    if (mode === 'cart') { window.location.href = root.dataset.cartUrl; return; }

    var drawer = document.querySelector('m-cart-drawer');
    var drawerOn = window.MinimogSettings && window.MinimogSettings.enable_cart_drawer;
    if (mode === 'drawer' && drawer && drawerOn && typeof drawer.onCartDrawerUpdate === 'function') {
      drawer.onCartDrawerUpdate();
      drawer.open();
      return;
    }

    document.querySelectorAll('.m-cart-count-bubble').forEach(function (c) {
      c.textContent = cart.item_count;
      c.classList.toggle('m:hidden', cart.item_count === 0);
    });
    var n = root.querySelector('[data-ecs-notice]');
    root.querySelector('[data-ecs-notice-msg]').textContent =
      qty + ' × ' + title + ' added. Cart: ' + cart.item_count + (cart.item_count === 1 ? ' item, ' : ' items, ') + money(cart.total_price, root);
    n.hidden = false;
    clearTimeout(n._t);
    n._t = setTimeout(function () { n.hidden = true; }, 8000);
  }

  function initRoot(root) {
    if (root.__ecsReady) return;
    root.__ecsReady = true;
    root.querySelectorAll('[data-ecs-card]').forEach(function (c) { initCard(c, root); });
    initNote(root);
    var close = root.querySelector('[data-ecs-notice-close]');
    if (close) close.addEventListener('click', function () { root.querySelector('[data-ecs-notice]').hidden = true; });
  }

  function boot() { document.querySelectorAll('[data-ecs-root]').forEach(initRoot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-ecs-root]').forEach(initRoot);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
